import { useMutation, useQueryClient } from '@tanstack/react-query';
import { docusignApi } from 'src/services/settings/integrations/docusign';
import { useMutationBuilder, useQueryBuilder } from 'src/query/useBuilders';
import {
  AUTHENTICATE,
  DELETE,
  DOCUSIGN,
  FETCH,
  INTEGRATIONS,
} from 'src/query/queryKeys';

export const useDocusignIntegrationFetch = () => {
  return useQueryBuilder([DOCUSIGN, FETCH], docusignApi.fetchIntegration, false, 0, true);
};

export const useDocusignAuthenticate = () => {
  return useMutationBuilder([DOCUSIGN, AUTHENTICATE], docusignApi.authenticate, [DOCUSIGN, FETCH]);
};

export const useDocusignDeactivate = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: [DOCUSIGN, DELETE],
    mutationFn: docusignApi.deactivate,
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: [DOCUSIGN, FETCH] });
      await queryClient.invalidateQueries({ queryKey: [INTEGRATIONS] });
    },
  });
};
